import { Component, OnInit, AfterViewInit, OnDestroy, Input } from "@angular/core";
import { Router } from "@angular/router";
import { DatePipe } from '@angular/common';
import { FlashMessagesService } from "angular2-flash-messages";
import { CclNavbarSecondaryService, CclSideNavItem, CclMessageService } from "certain-common-library";
import { SharedService } from "../../../../modules/shared/services/shared.service";
import { CatalogService } from "../../../../modules/shared/services/catalog.service";
import { SessionService } from "../../../../modules/shared/services/session-service";
import { LocalDataService } from "../../../../modules/shared/services/local-data.service";
import { Subscription } from "rxjs";
import { forkJoin } from "rxjs/observable/forkJoin";
import { cloneDeep } from "lodash";
import { AttendeeSessionService } from "../../../../modules/shared/services/attendee-session.service";
import * as moment from 'moment';
import 'moment-timezone';
import { filter } from "rxjs/operator/filter";

@Component({
    selector: "filter-section",
    templateUrl: "./filter-section.view.html",
    styleUrls: []
})
export class FilterSectionView implements OnInit, AfterViewInit, OnDestroy {
    private subscription: Subscription;
    filterConfig: any;
    private filterData: any = {};
    private selectedFilterData: any = {};
    private tracks: any;
    private types: any;
    private tags: any;
    private locations: any;
    private levels: any;
    private keysObj: any;
    private countExistFilter = 0;
    private tabConfig;
    public loginConfig: any;
    startEndObj: any;
    mySessions: any = {
        showMySessions: false,
        showMyFavorite: false,
        clearAll: true
    };
    timezone: any = {
        type : 'sessiontimezone',
        clearAll: true
    };
    timezoneArr: any = []
    sessionDate = [];
    sessionTime = [];
    allTime = {'id':"All Times", 'label':"All Times"}
    allDay = {'id':"All Days", 'label':"All Days"}
    private mySessionCount = 0;
    sessionDateCopy:any;
    sessionTimeCopy:any;
    standardFieldLabels: any = {};
    customFieldLabels: any = {};
    filterTextSearch: any = {};
    togglMySessionFilter: boolean = true;
    togglDateRangeFilter: boolean = false;
    fromClearSingle: boolean = false;
    generalDataConfig: any = {};
    toggle: boolean = false;
    @Input() filterPlacement: string;
    defaultTimeZoneKey: string;
    timezoneArray: any = [];
    minDate;
    maxDate;
    blankLabel: string = '(Blank)';
    presetFilterOption: any = {};
    hideFullSession: Boolean = false;
    hidePastSession: Boolean = false;
    sessionInstanceDateList:any = [];
    constructor(
        private datePipe: DatePipe,
        private navSecondaryService: CclNavbarSecondaryService,
        public sharedService: SharedService,
        private router: Router,
        private messageService: CclMessageService,
        private sessionService: SessionService,
        private localDataService: LocalDataService,
        private catalogService: CatalogService,
        private attendeeSessionService: AttendeeSessionService,
        private _flashMessagesService: FlashMessagesService
    ) {
        this.defaultTimeZoneKey = this.sharedService.event.timeZoneKey || this.sharedService.timezonekey
        moment.tz.setDefault(this.defaultTimeZoneKey);
        this.navSecondaryService.includeSave = false;
        this.subscription = this.messageService.getMessage().subscribe((message) => this.listenMessage(message));
        this.tabConfig = JSON.parse(this.sharedService.configs[this.sharedService.configTypes.TAB_CONFIG].config);
        this.generalDataConfig = JSON.parse(
            this.sharedService.configs[this.sharedService.configTypes.DATA.general].config
        );
    }

    async ngOnInit() {
        if (this.sharedService.configs[this.sharedService.configTypes.FILTER_CONFIG] != null) {
            this.filterConfig = JSON.parse(
                this.sharedService.configs[this.sharedService.configTypes.FILTER_CONFIG].config
            );

            if(!('selectTimezone' in this.filterConfig)) {
                this.filterConfig.selectTimezone = 'browser_timezone';
            }

            if (this.sharedService.event.eventDelivery === 'In Person' && this.filterConfig.isDefaultTimezone == true) {
                this.filterConfig.selectTimezone = 'event_timezone';
            }
        }

        if(!('showHidePastFilter' in this.generalDataConfig)) {
            this.generalDataConfig.showHidePastFilter = false;
        }

        if (this.sharedService.configs[this.sharedService.configTypes.LOGIN_POPUP] != null) {
            this.loginConfig = JSON.parse(
                this.sharedService.configs[this.sharedService.configTypes.LOGIN_POPUP].config
            );
        }

        this.filterConfig.selectedFields.forEach(element => {
            element.field_label = 'filter_section.' + element.field
        });


        if(this.sharedService.mysessions) {
            this.mySessions.showMyFavorite = false;
            this.mySessions.clearAll = false;
            this.mySessions.showMySessions = true;
        } else if(this.sharedService.myfav) {
            this.mySessions.showMyFavorite = true;
            this.mySessions.clearAll = false;
            this.mySessions.showMySessions = false;
        }

        if(this.loginConfig.restrictedBrowsing == true) {
            this.mySessions.showMyFavorite = false;
            this.mySessions.clearAll = false;
            this.mySessions.showMySessions = true;
        }

        let fieldDataMap: any = {};
        let fieldDataServiceArray: any = [];
        let standardFieldsCopy = cloneDeep(this.filterConfig.standardFields);
        this.selectedFilterData = this.sharedService.selectedFilterData;
        this.filterData = this.sharedService.filterData;
        let result = await this.sessionService.getSessionInstanceDates().toPromise();
        result.body["timeList"].forEach((date) => {
            this.sharedService.sessionTimes.push({
                id: date,
                label: date
            });
        });
        result.body["dateList"].forEach((date) => {
            this.sharedService.sessionDays.push({
                id: new Date(date),
                label: new Date(date)
            });
        });

        this.sessionInstanceDateList = result.body["dateList"];


        if(('showSessionDateRangePicker' in this.filterConfig && this.filterConfig.showSessionDateRangePicker)) {
            this.filterData["sessionDate"] = this.sharedService.sessionDays;
        }

        if(this.sharedService.filterName) {
            let result = await this.catalogService.getFilterPresetOptions().toPromise();
            let data: any;
            data = result.body;
            let temp = data.find(o => o.name === this.sharedService.filterName);
            if (!!temp) {
                this.presetFilterOption = JSON.parse(temp.filterConfig);
            }
            for (const property in this.presetFilterOption) {
                if(property == 'track' || property == 'type' || property == 'level'||
                property == 'location' || property == 'tag' ||property == 'industry' ||
                property == 'jobFunction') {
                    this.sharedService[property] = this.presetFilterOption[property];
                } 

                let hasCustomField = Object.keys(this.presetFilterOption).some(function(key) {
                    return /customField/.test(key);
                });
        
                if (hasCustomField) {
                    let customFieldArr = Object.entries(this.presetFilterOption).filter(function(key: any) {
                        return /customField/.test(key);
                    });
                    customFieldArr.forEach(element => {
                        this.sharedService.customField[element[0]] = element[1]
                    });
                }
            }
        }

        this.filterConfig.standardFields.forEach(async (element) => {
            this.selectedFilterData[element] = {};
            if (element == "track") {
                fieldDataServiceArray.push(this.sessionService.getSessionTracks());
            } else if (element == "sessionType") {
                fieldDataServiceArray.push(this.sessionService.getSessionTypes(this.sharedService.event.id));
            } else if (element == "tag") {
                fieldDataServiceArray.push(this.sessionService.getSessiontags());
            } else if (element == "location") {
                fieldDataServiceArray.push(this.sessionService.getSessionLocations(this.sharedService.event.id));
            } else if (element == "sessionLevel") {
                fieldDataServiceArray.push(this.sessionService.getSessionLevels(this.sharedService.event.id));
            } else if (element == "industry") {
                fieldDataServiceArray.push(
                    this.sessionService.getIndustries(this.sharedService.account.code, this.sharedService.event.code)
                );
            } else if (element == "jobFunction") {
                fieldDataServiceArray.push(
                    this.sessionService.getJobFunctions(this.sharedService.account.code, this.sharedService.event.code)
                );
            } else if (element == "productGoal") {
                fieldDataServiceArray.push(
                    this.sessionService.getProductGoals(this.sharedService.account.id, this.sharedService.event.id)
                );
            } else if (element == "sessionDate") {
                standardFieldsCopy.splice(standardFieldsCopy.indexOf("sessionDate"), 1);
                if (this.filterConfig.hasOwnProperty("selectedDates")) {
                    this.filterData["sessionDate"] = [];
                    this.filterConfig.selectedDates.sort(function(x, y){
                        return x - y;
                    });
                    if(this.filterConfig.selectTimezone == 'event_timezone') {
                        this.filterConfig.selectedDates.forEach((date) => {
                            this.filterData["sessionDate"].push({
                                id: new Date(date),
                                label: new Date(date)
                            });
                        });
                    } else {
                    // to filter time in case of browser timezone
                        let temp = []
                        result.body["dateList"].forEach(element => {
                                let test = new Date(element);
                                let label = moment(test).tz(this.sharedService.event.timeZoneKey).format(this.sharedService.dateFormat);
                                temp.push({id: element, label: label})
                        });
                        this.filterConfig.selectedDates.forEach(element => {
                                element = new Date(element);
                                element = moment(element).tz(this.sharedService.event.timeZoneKey).format(this.sharedService.dateFormat);
                                let datePart = element.split('T');
                                let filter = temp.filter(d => 
                                    d.label.includes(datePart[0])
                                )
                                filter.forEach((date) => {
                                    this.filterData["sessionDate"].push({
                                        id: new Date(date.id),
                                        label: new Date(date.id)
                                    });
                                });     
                        });

                        this.sharedService.filterSessionDateForBrowserTimezone = this.filterData["sessionDate"];
                    }
                } else {
                    this.filterData["sessionDate"] = this.sharedService.sessionDays;
                }
            } else if (element == "sessionTime") {
                standardFieldsCopy.splice(standardFieldsCopy.indexOf("sessionTime"), 1);
                if(this.filterConfig.hasOwnProperty("selectedTimes")) {
                    this.filterData["sessionTime"] = [];
                    this.filterConfig.selectedTimes.forEach((time) => {
                        this.filterData["sessionTime"].push({
                            id: time,
                            label: time
                        });
                    });
                } else {
                    this.filterData["sessionTime"] = this.sharedService.sessionTimes;
                }
            }
        });
        
        
        this.messageService.sendMessage("show-tab-on date-load");

        
        forkJoin(fieldDataServiceArray).subscribe((results) => {
            // TRACKS
            if (standardFieldsCopy.indexOf("track") >= 0) {
                if (this.generalDataConfig.hasOwnProperty("defaultFilters")) {
                    if (this.generalDataConfig.defaultFilters.track.length > 0) {
                        this.tracks = this.generalDataConfig.defaultFilters.track;
                    } else {
                        this.tracks = results[standardFieldsCopy.indexOf("track")]["body"]["data"];
                    }
                } else {
                    this.tracks = results[standardFieldsCopy.indexOf("track")]["body"]["data"];
                }
                this.filterData["track"] = [];
                this.tracks.forEach((element) => {
                    if(this.filterConfig.hasOwnProperty('selectedTracks')
                         && this.filterConfig.selectedTracks.indexOf(element.id) >=0) {
                        this.filterData["track"].push({
                            id: element.id,
                            label: element.trackName
                        });
                    }

                    if(!this.filterConfig.hasOwnProperty('selectedTracks')) {
                        this.filterData["track"].push({
                            id: element.id,
                            label: element.trackName
                        });
                    }
                });

                if((this.filterConfig.hasOwnProperty('selectedTracks') && this.filterConfig.selectedTracks.indexOf(null) >=0) || !this.filterConfig.hasOwnProperty('selectedTracks')) {
                    this.filterData["track"].push({
                        id: null,
                        label: this.blankLabel
                    });
                }

                if (this.sharedService.track && this.sharedService.track.length > 0) {
                    this.sharedService.track.forEach(element => {
                        this.selectedFilterData.track[element] = true
                    });
                    this.sharedService.preSetfilter = true;
                    this.showFilterContent['track'] = true;
                }
            }

            // TYPES
            if (standardFieldsCopy.indexOf("sessionType") >= 0) {
                if (this.generalDataConfig.hasOwnProperty("defaultFilters")) {
                    if (this.generalDataConfig.defaultFilters.type.length > 0) {
                        this.types = this.generalDataConfig.defaultFilters.type;
                    } else {
                        this.types = results[standardFieldsCopy.indexOf("sessionType")]["body"];
                    }
                } else {
                    this.types = results[standardFieldsCopy.indexOf("sessionType")]["body"];
                }
                this.filterData["sessionType"] = [];
                this.types.forEach((element) => {
                    if(this.filterConfig.hasOwnProperty('selectedTypes') && this.filterConfig.selectedTypes.indexOf(element.id) >=0) {
                        this.filterData["sessionType"].push({
                            id: element.id,
                            label: element.sessionType
                        });
                    }

                    if(!this.filterConfig.hasOwnProperty('selectedTypes')) {
                        this.filterData["sessionType"].push({
                            id: element.id,
                            label: element.sessionType
                        });
                    }
                });

                if((this.filterConfig.hasOwnProperty('selectedTypes') && this.filterConfig.selectedTypes.indexOf(null) >=0) || !this.filterConfig.hasOwnProperty('selectedTypes')) {
                    this.filterData["sessionType"].push({
                        id: null,
                        label: this.blankLabel
                    });
                }

                if (this.sharedService.type && this.sharedService.type.length > 0) {
                    this.sharedService.type.forEach(element => {
                        this.selectedFilterData.sessionType[element] = true
                    });
                    this.sharedService.preSetfilter = true;
                    this.showFilterContent['sessionType'] = true
                }
            }
            // TAGS
            if (standardFieldsCopy.indexOf("tag") >= 0) {
                if (this.generalDataConfig.hasOwnProperty("defaultFilters")) {
                    if (this.generalDataConfig.defaultFilters.tags && this.generalDataConfig.defaultFilters.tags.length > 0) {
                        this.tags = this.generalDataConfig.defaultFilters.tags;
                    } else {
                this.tags = results[standardFieldsCopy.indexOf("tag")]["body"]["page"]["content"];
                    }
                } else {
                    this.tags = results[standardFieldsCopy.indexOf("tag")]["body"]["page"]["content"];
                }               
                this.filterData["tag"] = [];
                this.tags.forEach((element) => {
                    if(this.filterConfig.hasOwnProperty('selectedTags') && this.filterConfig.selectedTags.indexOf(element.id) >=0) {
                        this.filterData["tag"].push({
                            id: element.id,
                            label: element.name
                        });
                    }

                    if(!this.filterConfig.hasOwnProperty('selectedTags')) {
                        this.filterData["tag"].push({
                            id: element.id,
                            label: element.name
                        });
                    }
                });

                if((this.filterConfig.hasOwnProperty('selectedTags') && this.filterConfig.selectedTags.indexOf(null) >=0) || !this.filterConfig.hasOwnProperty('selectedTags')) {
                    this.filterData["tag"].push({
                        id: null,
                        label: this.blankLabel
                    });
                }

                if (this.sharedService.tag && this.sharedService.tag.length > 0) {
                    this.sharedService.tag.forEach(element => {
                        this.selectedFilterData.tag[element] = true
                    });
                    this.showFilterContent['tag'] = true;
                    this.sharedService.preSetfilter = true;
                }
            }

            // LOCATIONS
            if (standardFieldsCopy.indexOf("location") >= 0) {
                this.locations = results[standardFieldsCopy.indexOf("location")]["body"]["data"];
                this.filterData["location"] = [];
                this.locations.forEach((element) => {
                    if(this.filterConfig.hasOwnProperty('selectedLocations') && this.filterConfig.selectedLocations.indexOf(element.id) >=0) {
                        this.filterData["location"].push({
                            id: element.id,
                            label: element.name
                        });
                    }

                    if(!this.filterConfig.hasOwnProperty('selectedLocations')) {
                        this.filterData["location"].push({
                            id: element.id,
                            label: element.name
                        });
                    }
                });

                if((this.filterConfig.hasOwnProperty('selectedLocations') && this.filterConfig.selectedLocations.indexOf(null) >=0) || !this.filterConfig.hasOwnProperty('selectedLocations')) {
                    this.filterData["location"].push({
                        id: null,
                        label: this.blankLabel
                    });
                }

                if (this.sharedService.location && this.sharedService.location.length > 0) {
                    this.sharedService.location.forEach(element => {
                        this.selectedFilterData.location[element] = true
                    });
                    this.sharedService.preSetfilter = true;
                    this.showFilterContent['location'] = true;
                }
            }

            // LEVELS
            if (standardFieldsCopy.indexOf("sessionLevel") >= 0) {
                this.levels = results[standardFieldsCopy.indexOf("sessionLevel")]["body"];
                this.filterData["sessionLevel"] = [];
                this.levels.forEach((element) => {
                    if(this.filterConfig.hasOwnProperty('selectedLevels') && this.filterConfig.selectedLevels.indexOf(element.id) >=0) {
                        this.filterData["sessionLevel"].push({
                            id: element.id,
                            label: element.levelName
                        });
                    }

                    if(!this.filterConfig.hasOwnProperty('selectedLevels')) {
                        this.filterData["sessionLevel"].push({
                            id: element.id,
                            label: element.levelName
                        });
                    }
                });

                if((this.filterConfig.hasOwnProperty('selectedLevels') && this.filterConfig.selectedLevels.indexOf(null) >=0) || !this.filterConfig.hasOwnProperty('selectedLevels')) {
                    this.filterData["sessionLevel"].push({
                        id: null,
                        label: this.blankLabel
                    });
                }

                if (this.sharedService.level && this.sharedService.level.length > 0) {
                    this.sharedService.level.forEach(element => {
                        this.selectedFilterData.sessionLevel[element] = true;
                    });
                    this.showFilterContent['sessionLevel'] = true;
                    this.sharedService.preSetfilter = true;
                }
            }

            // INDUSTRY
            if (standardFieldsCopy.indexOf("industry") >= 0) {
                this.levels = results[standardFieldsCopy.indexOf("industry")]["body"]["confIndustryDTOList"];
                this.filterData["industry"] = [];
                this.levels.forEach((element) => {
                    if(this.filterConfig.hasOwnProperty('selectedIndustries') && this.filterConfig.selectedIndustries.indexOf(element.id) >=0) {
                        this.filterData["industry"].push({
                            id: element.id,
                            label: element.name
                        });
                    }

                    if(!this.filterConfig.hasOwnProperty('selectedIndustries')) {
                        this.filterData["industry"].push({
                            id: element.id,
                            label: element.name
                        });
                    }
                });

                if((this.filterConfig.hasOwnProperty('selectedIndustries') && this.filterConfig.selectedIndustries.indexOf(null) >=0) || !this.filterConfig.hasOwnProperty('selectedIndustries')) {
                    this.filterData["industry"].push({
                        id: null,
                        label: this.blankLabel
                    });
                }


                if (this.sharedService.industry && this.sharedService.industry.length > 0) {
                    this.sharedService.industry.forEach(element => {
                        this.selectedFilterData.industry[element] = true
                    });
                    this.showFilterContent['industry'] = true;
                    this.sharedService.preSetfilter = true;
                }
            }

            // JOB FUNCTION
            if (standardFieldsCopy.indexOf("jobFunction") >= 0) {
                this.levels = results[standardFieldsCopy.indexOf("jobFunction")]["body"]["confJobFunctionDTOList"];
                this.filterData["jobFunction"] = [];
                this.levels.forEach((element) => {
                    if(this.filterConfig.hasOwnProperty('selectedJobFunctions') && this.filterConfig.selectedJobFunctions.indexOf(element.id) >=0) {
                        this.filterData["jobFunction"].push({
                            id: element.id,
                            label: element.name
                        });
                    }

                    if(!this.filterConfig.hasOwnProperty('selectedJobFunctions')) {
                        this.filterData["jobFunction"].push({
                            id: element.id,
                            label: element.name
                        });
                    }
                });

                if((this.filterConfig.hasOwnProperty('selectedJobFunctions') && this.filterConfig.selectedJobFunctions.indexOf(null) >=0) || !this.filterConfig.hasOwnProperty('selectedJobFunctions')) {
                    this.filterData["jobFunction"].push({
                        id: null,
                        label: this.blankLabel
                    });
                }

                if (this.sharedService.jobFunction && this.sharedService.jobFunction.length > 0) {
                    this.sharedService.jobFunction.forEach(element => {
                        this.selectedFilterData.jobFunction[element] = true
                    });
                    this.showFilterContent['jobFunction'] = true;
                    this.sharedService.preSetfilter = true;
                }
            }

            this.sharedService.selectedFilterData = this.selectedFilterData;
            this.sharedService.objectKeys(this.sharedService.selectedFilterData).forEach((filterKey) => {
                if(Object.keys(this.sharedService.selectedFilterData[filterKey]).length > 0) {
                    this.sharedService.clearAllFilterEnabled = true;
                }
            });
        },
        (error) => {
            this._flashMessagesService.show("Error loading filters");
        },
        () => {
            this.messageService.sendMessage("pre-filter-loaded");
        });

            this.sessionTimeCopy = cloneDeep(this.filterData["sessionTime"])
            this.sessionDateCopy = cloneDeep(this.filterData["sessionDate"])
            if(this.sharedService.timezone && this.filterConfig.selectTimezone == 'browser_timezone') {
                this.timezone = {
                    type : 'mytimezone',
                    clearAll: true
                };
                if(this.presetFilterOption.hasOwnProperty('selectedDate')) {
                    this.sharedService.selectedDayTime.day = moment(new Date(this.presetFilterOption['selectedDate'][0])).tz(this.sharedService.timezone).format(this.sharedService.dateFormat);
                    this.showFilterContent['sessionDate'] = true;
                    this.selectedFilterData['sessionDate'] = {
                        [this.sharedService.selectedDayTime.day]: true
                    }
                }

                if(this.presetFilterOption.hasOwnProperty('selectedTime')) {
                    let pstStartTime = moment(new Date()).tz(this.defaultTimeZoneKey).format();
                    let temp = pstStartTime.split("T");
                    let dateSTr = temp[0] + 'T' + this.convertTime12to24(this.presetFilterOption['selectedTime'][0]) + temp[1].substr(5);
                    this.sharedService.selectedDayTime.time = moment(dateSTr).tz(this.sharedService.timezone).format('hh:mm A');                
                    this.showFilterContent['sessionTime'] = true;
                    this.selectedFilterData['sessionTime'] = {
                        [this.sharedService.selectedDayTime.time]: true
                    }
                }
            
                if(this.filterData["sessionDate"] != null) {
                    this.filterData["sessionDate"].forEach(element => {
                        if(element.label) {
                            element.label = moment(element.label).tz(this.sharedService.timezone).format(this.sharedService.dateFormat);
                            element.id = element.label;
                            element.label = this.datePipe.transform(element.label,this.tabConfig.dateFormat);
                        } 
                    });
                }
                if(this.filterData["sessionTime"] != null) {
                    this.filterData["sessionTime"].forEach(element => {
                        if(element.label) {
                            let pstStartTime = moment(new Date()).tz(this.defaultTimeZoneKey).format();
                            let temp = pstStartTime.split("T");
                            let dateSTr = temp[0] + 'T' + this.convertTime12to24(element.label) + temp[1].substr(5);
                            element.label = moment(dateSTr).tz(this.sharedService.timezone).format('hh:mm A');
                            element.id = element.label
                        } 
                    });
                }
            } else {
                this.timezone = {
                    type : this.sharedService.event.timeZoneKey,
                    clearAll: true
                };
                if(this.filterData["sessionDate"] != null) {
                    this.filterData["sessionDate"].forEach(element => {
                        if(element.label) {
                            element.label = moment(element.label).format(this.sharedService.dateFormat);
                            element.id = element.label;
                            element.label = this.datePipe.transform(element.label,this.tabConfig.dateFormat);
                        } 
                    });
                }
                if(this.presetFilterOption.hasOwnProperty('selectedDate')) {
                    this.sharedService.selectedDayTime.day = moment(new Date(this.presetFilterOption['selectedDate'][0])).format(this.sharedService.dateFormat);
                    this.showFilterContent['sessionDate'] = true;
                    this.selectedFilterData['sessionDate'] = {
                        [this.sharedService.selectedDayTime.day]: true
                    }
                }

                if(this.presetFilterOption.hasOwnProperty('selectedTime')) {
                    this.sharedService.selectedDayTime.time = this.presetFilterOption['selectedTime'][0]                
                    this.showFilterContent['sessionTime'] = true;
                    this.selectedFilterData['sessionTime'] = {
                        [this.sharedService.selectedDayTime.time]: true
                    }
                }
            }
            let temp = [];
            this.filterData["sessionDate"]?.forEach(element => {
                if(temp.findIndex(item => item.label === element.label) == -1) {
                    temp.push(element);
                }
            });
            this.filterData["sessionDate"] = temp;

            if(this.filterData["sessionDate"] && this.filterData["sessionDate"].length > 0) {
                this.minDate = moment(this.filterData["sessionDate"][0].id);
                this.maxDate = moment(this.filterData["sessionDate"][this.filterData["sessionDate"].length-1].id);
            }


            if(this.filterData["sessionDate"] && this.filterData["sessionDate"].length>0) {
                this.sessionDate = [this.allDay,...this.filterData["sessionDate"]]
            }

            if(this.filterData["sessionTime"] && this.filterData["sessionTime"].length>0) {
                this.sessionTime = [this.allTime, ...this.filterData["sessionTime"]]
            }
        this.localDataService.getJSON("filter-standardFields.json").subscribe((data) => {
            if (data != null) {
                data.forEach((element) => {
                    this.standardFieldLabels[element.code] = element.label;
                });
            }
        });

        this.catalogService
            .getCustomFieldList({
                eventId: this.sharedService.event.id,
                objectType: "SESSION",
                isCustomFieldUsedInLayout: true
            })
            .subscribe((resp) => {
                this.sharedService.sessionCustomFields = resp.body["data"];
                if (this.sharedService.sessionCustomFields != null) {
                    let enumCustomFields = [];
                    let fileCustomFields = [];
                    this.sharedService.sessionCustomFields.forEach((cf) => {
                        if (
                            cf.questionTypeId == 4 ||
                            cf.questionTypeId == 5 ||
                            cf.questionTypeId == 6 ||
                            cf.questionTypeId == 7
                        ) {
                            enumCustomFields.push(cf);
                        } else if (cf.questionTypeId == 19) {
                            fileCustomFields.push(cf);
                        }
                    });
                    this.sharedService.sessionEnumCustomFields = enumCustomFields;
                    this.sharedService.sessionFileCustomFields = fileCustomFields;
                    this.sharedService.sessionEnumCustomFields.forEach((customField) => {
                        this.customFieldLabels["customField_" + customField.id] = customField.name;
                        this.filterData["customField_" + customField.id] = [];
                        this.selectedFilterData["customField_" + customField.id] = {};
                        if (this.sharedService.customField["customField_" + customField.id] && this.sharedService.customField["customField_" + customField.id].length > 0) {
                            this.sharedService.customField["customField_" + customField.id].forEach(elem => {
                                this.selectedFilterData["customField_" + customField.id][elem] = true
                            });
                            this.showFilterContent["customField_" + customField.id] = true;
                            this.sharedService.preSetfilter = true;
                        }
                        customField.options.sort((a, b) => a.order - b.order)
                        customField.options.forEach((option) => {
                            if(this.filterConfig.hasOwnProperty('selectedOptions') && this.filterConfig.selectedOptions['customField_' + customField.id]?.length > 0 && this.filterConfig.selectedOptions['customField_' + customField.id].indexOf(option.id) >= 0) {
                                this.filterData["customField_" + customField.id].push({
                                    id: option.id,
                                    label: option.name,
                                    name: customField.name + " : "
                                });
                            }

                            if(!this.filterConfig.hasOwnProperty('selectedOptions')) {
                                this.filterData["customField_" + customField.id].push({
                                    id: option.id,
                                    label: option.name,
                                    name: customField.name + " : "
                                });
                            }
                        });
                        if(this.filterConfig.hasOwnProperty('selectedOptions') && this.filterConfig.selectedOptions['customField_' + customField.id]?.length > 0 && this.filterConfig.selectedOptions['customField_' + customField.id].indexOf(null) >= 0) {
                            this.filterData["customField_" + customField.id].push({
                                id: null,
                                label: this.blankLabel,
                                name: customField.name + " : "
                            });
                        }
                    });
                    this.sharedService.selectedFilterData = this.selectedFilterData;
                    this.sharedService.objectKeys(this.sharedService.selectedFilterData).forEach((filterKey) => {
                        if(Object.keys(this.sharedService.selectedFilterData[filterKey]).length > 0) {
                            this.sharedService.clearAllFilterEnabled = true;
                        }
                    })
                }
            },
            (error) => {
                this._flashMessagesService.show("Error loading custom fields");
            }, () => {
                this.messageService.sendMessage("pre-filter-loaded");
            });

        if (this.sharedService.loggedInAttendee != null) {
            this.attendeeSessionService.getFavoritesData(this.sharedService.loggedInAttendee.uuid).subscribe((resp) => {
                this.sharedService.excData.sessions = [];
                resp.body["sessions"].forEach((element) => {
                    if (element.isExcluded) {
                        this.sharedService.excData.sessions.push(element);
                    }
                });
                this.sharedService.excData.size = this.sharedService.excData.sessions.length;
            });

        }

        this.catalogService.getTimeZone().subscribe((resp:any) => {
            this.timezoneArray = this.sharedService.timezoneSort(resp.body);
            this.timezoneArr = [{'timeKeyName':"mytimezone", 'displayName': this.sharedService.timezone },
    ...this.timezoneArray
    ]
        })
    }

    ngAfterViewInit(): void {}

    ngOnDestroy() {
        this.sharedService.unsubscribeHelper(this.subscription);
    }

    getFilterExist(obj) {
        let keysObjType = Object.keys(this.selectedFilterData[obj]);
        keysObjType.forEach((tr) => {
            if (this.selectedFilterData[obj][tr] && tr != "allDay") {
                this.countExistFilter = this.countExistFilter + 1;
            }
        });
    }

    compare( a, b ) {
        if ( a.label.toLowerCase() < b.label.toLowerCase() ){
          return -1;
        }
        if ( a.label.toLowerCase() > b.label.toLowerCase() ){
          return 1;
        }
        return 0;
      }

    listenMessage(message) {
        this.keysObj = Object.keys(this.selectedFilterData);
        if (message.text == "clear-all-filter") {
            this.clearAllFilter();
        } else if (message.text == "clear-single-filter") {
            this.keysObj.forEach((obj) => {
                this.getFilterExist(obj);
            });
            if (this.countExistFilter <= 1) {
                this.clearAllFilter();
            } else {
                this.fromClearSingle = true;
                this.selectFilter(message.data.filterType, message.data.id);
            }
            this.countExistFilter = 0;
        } else if (message.text == "changed-date") {
            this.selectedFilterData["sessionDate"] = {};
            if(message.data.selectTab) {
                this.sharedService.selectedDayTime.day = message.data.selectTab != 'allDay' ? message.data.selectTab : 'All Days';
            }
            this.keysObj.forEach((obj) => {
                this.getFilterExist(obj);
            });
            if (message.data.selectTab == "allDay" && this.countExistFilter < 1) {
                this.clearAllFilter();
            } else {
                this.selectFilter("sessionDate", message.data.selectTab);
            }
            this.countExistFilter = 0;
        }
    }

    showFilterContent: any = {};

    toggleFilterContent(filterType) {
        this.showFilterContent[filterType] = !this.showFilterContent[filterType];
    }

    toggleFunc() {
        this.toggle = !this.toggle
    }

    mySessionToggle() {
        if (this.sharedService.generalListLoading) {
            return false;
        }
        this.togglMySessionFilter = !this.togglMySessionFilter;
    }

    toggleDateRangePicker() {
        if (this.sharedService.generalListLoading) {
            return false;
        }
        this.togglDateRangeFilter = !this.togglDateRangeFilter;
    }

    selectFilter(filterType, id) {
        if (this.sharedService.generalListLoading) {
            return false;
        }

        let temp
        if (filterType == 'sessionDate' || filterType == 'sessionTime') {
            if (this.selectedFilterData[filterType].hasOwnProperty(id)) {
                if(filterType == 'sessionDate') {
                    this.sharedService.selectedDayTime.day = "All Days";
                } else {
                    this.sharedService.selectedDayTime.time = "All Times";
                }
                id = ''
            }
            this.selectedFilterData[filterType] = {};
            temp = this.selectedFilterData[filterType];
        } else {
            temp = this.selectedFilterData[filterType];
        }

        if (temp == null) {
            temp = {};
        }
        let countSessionDate = 0;
        if (this.selectedFilterData["sessionDate"]) {
            let filterSessionDate = Object.keys(this.selectedFilterData["sessionDate"]);
            filterSessionDate.forEach((obj) => {
                if (this.selectedFilterData["sessionDate"][obj]) {
                    ++countSessionDate;
                }
            });
        }

        if (this.fromClearSingle && filterType === "sessionDate" && countSessionDate <= 1) {
            this.selectedFilterData[filterType] = { allDay: true };
            this.fromClearSingle = false;

            this.messageService.sendMessage("set-all-day", {
                selectTab: "allDay"
            });
        } else {
            if (id && id != 'All Days' && id != 'All Times') {
                temp[id] = !temp[id];
                this.selectedFilterData[filterType] = temp;
            } else if(id == null) {
                temp[id] = !temp[id];
                this.selectedFilterData[filterType] = temp;
            }
            this.fromClearSingle = false;
        }
        this.countExistFilter = 0;
        this.toggleClearAll();
    }

    clearAllFilter() {
        for (const property in this.filterTextSearch) {
            this.filterTextSearch[property] = "";
        }
        this.sharedService.excData.size = 0;
        this.sharedService.excData.instanceId = [];
        if (this.sharedService.generalListLoading) {
            return false;
        }
        this.filterConfig.standardFields.forEach((element) => {
            this.selectedFilterData[element] = {};
        });
        this.filterConfig.customFields.forEach((element) => {
            this.selectedFilterData[element] = {};
        });
        if (this.selectedFilterData.hasOwnProperty("speaker")) {
            this.selectedFilterData["speaker"] = {};
        }
        if (this.selectedFilterData.hasOwnProperty("sessionDate")) {
            this.selectedFilterData["sessionDate"] = {};
        }
        this.hideFullSession = false;
        this.hidePastSession = false;
        this.sharedService.selectedDayTime.day = "All Days";
        this.sharedService.selectedDayTime.time = "All Times";
        this.startEndObj = null;
        this.sharedService.selectedDates = null;
        this.messageService.sendMessage("clear-text-search-field");
        this.countExistFilter = 0;
        this.clearAllSessionFilter();
        this.toggleClearAll();
    }

    toggleClearAll() {
        if (this.sharedService.generalListLoading) {
            return false;
        }
        this.sharedService.clearAllFilterEnabled = false;
        this.sharedService.objectKeys(this.selectedFilterData).forEach((filterKey) => {
            if (!this.sharedService.clearAllFilterEnabled) {
                let tempArray = this.selectedFilterData[filterKey];
                this.sharedService.objectKeys(tempArray).forEach((temp) => {
                    if (!this.sharedService.clearAllFilterEnabled && (tempArray[temp] || tempArray[temp] == "true")) {
                        this.sharedService.clearAllFilterEnabled = true;
                    }
                });
            }
        });
        if (!this.sharedService.speakerFilterApplied) {
            this.messageService.sendMessage("apply-session-filters", { hideFullSession: this.hideFullSession, hidePastSession: this.hidePastSession });
        }
    }

    clearAllSessionFilter() {
        if (this.sharedService.generalListLoading) {
            return false;
        }
        this.mySessions = {
            showMySessions: this.loginConfig.restrictedBrowsing == true ? true : false,
            showMyFavorite: false,
            clearAll: true
        };

        this.messageService.sendMessage("apply-mysession-clearAll");
        if(!this.loginConfig.restrictedBrowsing) {
            $("#one").prop("checked", false);
        }

        $("#two").prop("checked", false);
    }

    toggleMySessionFilter(type) {
        if (this.sharedService.generalListLoading) {
            return false;
        }

        if (this.loginConfig.restrictedBrowsing == true) {
            $("#two").prop("checked", false);
            return false;
        }
        this.mySessionCount += 1;
        if (this.mySessionCount % 2 == 0) {
            if (type == "scheduled") {
                this.mySessions.showMyFavorite = false;
                this.mySessions.clearAll = false;
                this.mySessions.showMySessions = true;

                this.messageService.sendMessage("apply-mysession-checkbox");
            } else if (type == "favorite") {
                this.mySessions.showMySessions = false;
                this.mySessions.clearAll = false;
                this.mySessions.showMyFavorite = true;

                this.messageService.sendMessage("apply-myfavsession-checkbox");
            }
        }
    }

    hideSessions(type) {
        if(type == 'full') {
            this.hideFullSession = !this.hideFullSession;
        } else {
            this.hidePastSession = !this.hidePastSession;
        }
        this.messageService.sendMessage("apply-hide-session", { hideFullSession: this.hideFullSession, hidePastSession: this.hidePastSession });
    }


    toggleTimeZone(type) {
        event.preventDefault();
        if(type == 'mytimezone') {
            this.filterData["sessionTime"] = cloneDeep(this.sessionTimeCopy)
            this.filterData["sessionDate"] = cloneDeep(this.sessionDateCopy)
            this.sharedService.timezone = moment.tz.guess(true);
            if(this.sharedService.timezone) {
                if(this.filterData["sessionDate"]){
                    for (let i = 0; i < this.filterData["sessionDate"].length; i++) {
                        if(this.filterData["sessionDate"][i].label) {
                            this.filterData["sessionDate"][i].label = moment(this.filterData["sessionDate"][i].label).tz(this.sharedService.timezone).format();
                            this.filterData["sessionDate"][i].id = this.filterData["sessionDate"][i].label
                        } 
                    }
                }
                if(this.filterData["sessionTime"]){
                    for (let i = 0; i < this.filterData["sessionTime"].length; i++) {
                        if(this.filterData["sessionTime"][i].label) {
                            let pstStartTime = moment(new Date()).tz(this.defaultTimeZoneKey).format();
                            let temp = pstStartTime.split("T");
                            let dateSTr = temp[0] + 'T' + this.convertTime12to24(this.filterData["sessionTime"][i].label) + temp[1].substr(5);
                            this.filterData["sessionTime"][i].label = moment(dateSTr).tz(this.sharedService.timezone).format('hh:mm A');
                            this.filterData["sessionTime"][i].id = this.filterData["sessionTime"][i].label
                        } 
                    }
                }
            }
        // } else if(type == 'sessiontimezone') {
        //     this.sharedService.timezone = '';
        //     this.filterData["sessionDate"] = this.sessionDateCopy;
        //     this.filterData["sessionTime"] = this.sessionTimeCopy;
        //     // this.visibleTimeZone = 'sessiontimezone'
        //     this.messageService.sendMessage("apply-session-timezone")
        } else {
            this.sharedService.timezone = type;
            this.filterData["sessionDate"] = cloneDeep(this.sessionDateCopy);
            this.filterData["sessionTime"] = cloneDeep(this.sessionTimeCopy);
            if(this.sharedService.timezone) {
                if(this.filterData["sessionDate"]){
                    for (let i = 0; i < this.filterData["sessionDate"].length; i++) {
                        if(this.filterData["sessionDate"][i].label) {
                            this.filterData["sessionDate"][i].label = moment(this.filterData["sessionDate"][i].label).tz(this.sharedService.timezone).format(this.sharedService.dateFormat);
                            this.filterData["sessionDate"][i].id = this.filterData["sessionDate"][i].label
                        } 
                    }
                }
                if(this.filterData["sessionTime"]){
                    for (let i = 0; i < this.filterData["sessionTime"].length; i++) {
                        if(this.filterData["sessionTime"][i].label) {
                            let pstStartTime = moment(new Date()).tz(this.defaultTimeZoneKey).format();
                            let temp = pstStartTime.split("T");
                            let dateSTr = temp[0] + 'T' + this.convertTime12to24(this.filterData["sessionTime"][i].label) + temp[1].substr(5);
                            this.filterData["sessionTime"][i].label = moment(dateSTr).tz(this.sharedService.timezone).format('hh:mm A');
                            this.filterData["sessionTime"][i].id = this.filterData["sessionTime"][i].label
                        } 
                    }
                }
            }
        }

        if(this.filterConfig.selectTimezone == 'event_timezone' && this.filterConfig.hasOwnProperty("selectedDates")) {
            let temp = []
            this.filterData["sessionDate"] = [];
            this.filterConfig.selectedDates.sort(function(x, y){
                    return x - y;
            });
            this.sessionInstanceDateList.forEach(element => {
                let date = new Date(element);
                let label = moment(date).format(this.sharedService.dateFormat);
                temp.push({id: element, label: label})
            });
            this.filterConfig.selectedDates.forEach(element => {
                    element = new Date(element);
                    element = moment(element).format(this.sharedService.dateFormat);
                    let datePart = element.split('T');
                    let filter = temp.filter(d => 
                        d.label.includes(datePart[0])
                    )
                    filter.forEach((date) => {
                        this.filterData["sessionDate"].push({
                            id: new Date(date.id),
                            label: new Date(date.id)
                        });
                    });     
            });

            if(this.filterData["sessionDate"] != null) {
                this.filterData["sessionDate"].forEach(element => {
                    if(element.label) {
                        element.label = moment(element.label).format(this.sharedService.dateFormat);
                        element.id = element.label;
                        element.label = this.datePipe.transform(element.label,this.tabConfig.dateFormat);
                    } 
                });
            }
            this.sharedService.filterSessionDateForBrowserTimezone = this.filterData["sessionDate"];               
        }

        this.sharedService.selectedFilterData['sessionDate'] = {};
        this.sharedService.selectedFilterData['sessionTime'] = {};
        this.sharedService.selectedDayTime.day = "All Days";
        this.sharedService.selectedDayTime.time = "All Times";
        this.sharedService.clearAllFilterEnabled = false;
        this.sharedService.objectKeys(this.sharedService.selectedFilterData).forEach((filterKey) => {
            if(Object.keys(this.sharedService.selectedFilterData[filterKey]).length > 0) {
                this.sharedService.clearAllFilterEnabled = true;
            }
        });

        if(this.sharedService.timezone == this.defaultTimeZoneKey) {
            this.messageService.sendMessage("apply-my-timezone", { text : 'event_timezone' });
        } else {
            this.messageService.sendMessage("apply-my-timezone");
        }

        if(this.filterData["sessionDate"] != null) {
            this.filterData["sessionDate"].forEach(element => {
                if(element.label) {
                    element.label = this.datePipe.transform(element.label,this.tabConfig.dateFormat);
                } 
            });
        }

        let temp = [];
        this.filterData["sessionDate"]?.forEach(element => {
            if(temp.findIndex(item => item.label === element.label) == -1) {
                temp.push(element);
            }
        });
        this.filterData["sessionDate"] = temp;
        
        if(this.filterData["sessionDate"] && this.filterData["sessionDate"].length > 0) {
            this.sessionDate = [this.allDay,...this.filterData["sessionDate"]]
        } 
    
        if(this.filterData["sessionTime"] && this.filterData["sessionTime"].length > 0) {
            this.sessionTime = [this.allTime, ...this.filterData["sessionTime"]]
        }
        
        this.messageService.sendMessage("change-timezone", {
            sessionDate: this.filterData["sessionDate"]
        });
    }

    removeAll(isExcluded) {
        if (this.sharedService.generalListLoading) {
            return false;
        }
        
        if (isExcluded) {
            this.sharedService.excData.size = 0;
            this.sharedService.excData.instanceId = [];
        }
        this.messageService.sendMessage("unhide-sessions");
    }

    convertTime12to24(time12h) {
        const [time, modifier] = time12h.split(' ');
      
        let [hours, minutes] = time.split(':');
      
        if (hours === '12') {
          hours = '00';
        }
      
        if (modifier === 'PM') {
          hours = parseInt(hours, 10) + 12;
        }
      
        return `${hours}:${minutes}`;
    }

    change(e) {
        this.sharedService.selectedDates = e;
        if(this.sharedService.selectedDates.startDate != null && this.sharedService.selectedDates.endDate != null) {
            this.sharedService.selectedDates.startDate = moment(this.sharedService.selectedDates.startDate).format('YYYY-MM-DD');
            this.sharedService.selectedDates.endDate = moment(this.sharedService.selectedDates.endDate).format('YYYY-MM-DD');
            this.messageService.sendMessage("apply-session-filters", { hideFullSession: this.hideFullSession, hidePastSession: this.hidePastSession });
        }
    }
}
